import { initLegalStatus } from 'library-@/components/legal-tag/legal-config';

const state = {
    historySelectedList: [],
    historySelectedRefObj: {},
    exportSelectedData: {}, // 导出选中
    addWorkSpacePermission: false,
    legalConfig: {}
};

const getters = {
    historySelectedList(state) {
        return state.historySelectedList;
    },
    historySelectedRefObj(state) {
        return state.historySelectedRefObj;
    },
    exportSelectedData(state) {
        return state.exportSelectedData;
    },
    addWorkSpacePermission(state) {
        return state.addWorkSpacePermission;
    },
    legalConfig(state) {
        return state.legalConfig;
    },
};

const mutations = {
    updateHistorySelectedList(state, historySelectedList) {
        state.historySelectedList = historySelectedList;
    },
    updateHistorySelectedRefObj(state, historySelectedRefObj) {
        state.historySelectedRefObj = historySelectedRefObj;
    },
    updateExportSelectedData(state, exportSelectedData) {
        state.exportSelectedData = exportSelectedData;
    },
    updateWorkSpacePermission(state, addWorkSpacePermission) {
        state.addWorkSpacePermission = addWorkSpacePermission;
    },
    initLegalConfig(state, config) {
        state.legalConfig = config;
    }
};

const actions = {
    updateHistorySelectedList({ commit }, historySelectedList) {
        commit('updateHistorySelectedList', historySelectedList);
    },
    updateHistorySelectedRefObj({ commit }, historySelectedRefObj) {
        commit('updateHistorySelectedRefObj', historySelectedRefObj);
    },
    updateExportSelectedData({ commit }, exportSelectedData) {
        commit('updateExportSelectedData', exportSelectedData);
    },
    updateWorkSpacePermission({ commit }, addWorkSpacePermission) {
        commit('updateWorkSpacePermission', addWorkSpacePermission);
    },
    async initLegalConfig({commit}) {
        const legalConfig = await initLegalStatus()
        commit('initLegalConfig', legalConfig);
    }
};


export default {
    state,
    getters,
    mutations,
    actions
};
